module.exports = __webpack_public_path__ + "static/media/formkit_help.e3aaface.svg";